import { useMemo } from "react"

import { IS_MEZO_MAINNET, routes } from "#/shared/constants"
import { useTabsNavigation } from "#/shared/hooks"
import { LeaderboardPageTab } from "#/shared/types"

import { Tabs } from "../Tabs"

import LeaderboardMatsTab from "./LeaderboardMatsTab"
import LeaderboardSatsTab from "./LeaderboardSatsTab"

export default function LeaderboardTabs() {
  const { activeTab, onChangeTab } = useTabsNavigation(
    LeaderboardPageTab.MATS,
    routes.LEADERBOARD,
  )

  const tabsItems = useMemo(
    () => [
      {
        key: LeaderboardPageTab.MATS,
        title: "mats",
        children: <LeaderboardMatsTab />,
      },
      {
        key: LeaderboardPageTab.SATS,
        title: "Sats",
        children: <LeaderboardSatsTab />,
      },
    ],
    [],
  )

  return IS_MEZO_MAINNET ? (
    <LeaderboardMatsTab />
  ) : (
    <Tabs onChange={onChangeTab} activeKey={activeTab} tabs={tabsItems} />
  )
}
